<template>
	<v-container>
		<v-row>
			<v-col cols='12'>
				<h2>{{ result.sortition.name }}</h2>
				<h4>
					{{ result.date }}
				</h4>
			</v-col>
		</v-row>
		<v-row v-if='result.first || result.second || result.third' justify='center' no-gutters>
			<v-col cols='auto' class='mx-1'>
				<digit-image-display display-as-one class='d-flex' :digit='result.first'
														 :image-dimensions='imageDimensions' />
				<h5>
					1st
				</h5>
			</v-col>
			<v-col cols='auto' class='mx-1'>
				<digit-image-display display-as-one class='d-flex' :digit='result.second'
														 :image-dimensions='imageDimensions' />
				<h5>
					2nd
				</h5>
			</v-col>
			<v-col cols='auto' class='mx-1'>
				<digit-image-display display-as-one class='d-flex' :digit='result.third'
														 :image-dimensions='imageDimensions' />
				<h5>
					3rd
				</h5>
			</v-col>
		</v-row>
		<v-row v-if='result.pickOne' no-gutters class='align-center flex-column'>
			<v-col cols='auto'>
				<v-img class='d-flex align-self-center' v-if='pickOneImage' :src='pickOneImage.src' :width='pickOneImage.width'
							 contain></v-img>
				<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 1</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display :digit='result.pickOne' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
		<v-row v-if='result.pickTwo' no-gutters class='align-center flex-column'>
			<v-col cols='auto'>
				<v-img v-if='pickTwoImage' :src='pickTwoImage.src' :width='pickTwoImage.width'></v-img>
				<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 2</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display :digit='result.pickTwo' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
		<v-row v-if='result.cashThree' no-gutters class='align-center flex-column'>
			<v-col cols='auto'>
				<v-img v-if='pickThreeImage' :src='pickThreeImage.src' :width='pickThreeImage.width'></v-img>
				<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display class='d-flex' :digit='result.cashThree' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
		<v-row v-if='result.pickFour' no-gutters class='align-center flex-column'>
			<v-col cols='auto' align-self='center'>
				<v-img v-if='pickFourImage' :src='pickFourImage.src' :width='pickFourImage.width'></v-img>
				<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 4</span>
			</v-col>
			<v-col cols='auto'>
				<digit-image-display class='d-flex' horizontal :digit='result.pickFour' :image-dimensions='imageDimensions' />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DigitImageDisplay from '@/homepage/components/DigitImageDisplay.vue';
import ResultDisplay from '@homepage/components/ResultDisplay.js';

export default {
	name: 'ResultVerticalDisplay',
	extends: ResultDisplay,
	components: {
		DigitImageDisplay
	}
};
</script>

<style>
</style>
